import { useEffect } from 'react';
import { FaInfo } from 'react-icons/fa';
import Dropdown from 'react-bootstrap/Dropdown';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { push, useRouteMatch } from '../../app/route';
import {
  selectCurrentTenantId,
} from '../user/userSlice';
import {
  selectScopesAndActions,
  listScopesAction,
  deleteScopeAction,
  getScopeListUrl,
  getScopeCreateUrl,
  getScopeDetailUrl,
} from './scopeSlice';
import { hasAnyAction } from '../../common/has-any-action';

type PathParams = {
  tenant_id: string;
};

export function ScopeListPage() {
  const dispatch = useAppDispatch();
  const scopes = useAppSelector(selectScopesAndActions);
  const tenant_id = useAppSelector(selectCurrentTenantId);
  const match = useRouteMatch<PathParams>();

  useEffect(() => {
    if (match.params.tenant_id !== tenant_id) {
      dispatch(push(getScopeListUrl(tenant_id)));
    }
  }, [tenant_id, match, dispatch]);
  useEffect(() => {
    dispatch(listScopesAction({ tenant_id }));
  }, [tenant_id, dispatch]);

  const goDetail = (mode: 'view'|'edit', scope_name: string) => {
    dispatch(push(getScopeDetailUrl(tenant_id, scope_name, mode)));
  };
  const goCreate = () => {
    dispatch(push(getScopeCreateUrl(tenant_id)));
  };
  const handleDeleteScope = async(scope_name: string) => {
    let result = await dispatch(deleteScopeAction({
      tenant_id,
      scope_name
    }));
    if (deleteScopeAction.fulfilled.match(result)) {
      dispatch(listScopesAction({ tenant_id }));
    }
  };
  return (
    <div className="container">
      <div className="d-flex justify-content-between py-4">
        <h1>Scope</h1>
        <button className="btn btn-primary my-2" onClick={() => goCreate()}>
          Create
        </button>
      </div>
      <table className="table">
        <thead className="table-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col">ScopeId</th>
            <th scope="col">Name</th>
            <th scope="col">Title</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {scopes.map((scope, index) => {
            return (
              <tr key={index}>
                <th scope="row">{ index+1 }</th>
                <td>{scope.scope_id}</td>
                <td>{scope.name}</td>
                <td>{scope.title}</td>
                <td>
                  {hasAnyAction(scope.$action) &&
                  <Dropdown>
                    <Dropdown.Toggle variant="dark" id={'action-'+index}>
                      <FaInfo/>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      { scope.$action.can_edit &&
                        <Dropdown.Item onClick={() => goDetail('edit', scope.name)}>Edit</Dropdown.Item>
                      }
                      { scope.$action.can_view &&
                        <Dropdown.Item onClick={() => goDetail('view', scope.name)}>View</Dropdown.Item>
                      }
                      { scope.$action.can_delete &&
                        <Dropdown.Item onClick={() => handleDeleteScope(scope.name)}>Delete</Dropdown.Item>
                      }
                    </Dropdown.Menu>
                  </Dropdown>
                  }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
